import { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import { ArrowRight, Rocket } from 'lucide-react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const thumbnails = [
  { src: '/images/voxelo.png', label: 'AI Platform' },
  { src: '/images/redsun.png', label: 'Fintech Brand' },
  { src: '/images/cosematics.png', label: 'E-Commerce' },
]

export default function CTABanner() {
  const sectionRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const ctx = gsap.context(() => {
      const elements = sectionRef.current?.querySelectorAll('.cta-animate')
      if (elements && elements.length > 0) {
        gsap.fromTo(elements, { y: 40, opacity: 0 }, {
          y: 0, opacity: 1, duration: 0.8, stagger: 0.1, ease: 'power3.out',
          scrollTrigger: { trigger: sectionRef.current, start: 'top 80%', toggleActions: 'play none none none' }
        })
      }
    }, sectionRef)
    return () => ctx.revert()
  }, [])

  return (
    <section ref={sectionRef} className="bg-[#050505] py-16 lg:py-24 px-6 lg:px-10">
      <div className="cta-animate bg-gradient-to-r from-[#B7000E] via-[#b7000f94] to-[#b7000f5f] rounded-3xl p-8 lg:p-12">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
          <div>
            <span className="text-mono text-[#9A9A9A] mb-3 block">LET'S WORK TOGETHER</span>
            <h2 className="text-h3 uppercase text-white mb-4">
              READY TO BUILD<br />SOMETHING GREAT?
            </h2>
            <p className="text-[#9A9A9A] max-w-md mb-6">
              Whether you need a new website, a custom CRM, an online store, or an AI-powered solution —
              we are ready to turn your vision into reality. Get a free consultation and detailed proposal.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link to="/contacts" className="btn-primary">
                <Rocket className="w-4 h-4" />
                START YOUR PROJECT
                <ArrowRight className="w-4 h-4" />
              </Link>
              <Link to="/services" className="btn-outline">
                EXPLORE SERVICES
              </Link>
            </div>
          </div>

          <div className="flex gap-3 shrink-0">
            {thumbnails.map((t, i) => (
              <div key={i} className="w-20 h-14 lg:w-28 lg:h-20 rounded-xl overflow-hidden relative group">
                <img src={t.src} alt={t.label} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                <div className="absolute inset-0 bg-black/30" />
              </div>
            ))}
          </div>
        </div>

        {/* Trust signals */}
        <div className="mt-10 pt-8 border-t border-white/5 flex flex-wrap gap-8 items-center">
          {[
            { value: 'Free', label: 'Consultation' },
            { value: '24h', label: 'Response Time' },
            { value: '150+', label: 'Happy Clients' },
            { value: '7', label: 'Core Services' },
          ].map((s) => (
            <div key={s.label}>
              <span className="text-xl font-light text-white">{s.value}</span>
              <span className="text-mono text-[#9A9A9A] ml-2">{s.label.toUpperCase()}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
